module.exports = __webpack_public_path__ + "img/efinans2025.9de42d38.jpg";